import React from 'react';
import { BringzzIcon, BringzzText } from "@bringzz/components";
import { useNavigation } from "context/NavigationContext";

const BringzzPharmacyCardSmall = ({ pharmacy, pharmacist }) => {
    const { navigate } = useNavigation();

    if (!pharmacy) {
        return (
            <div className='flex space-x-4 border-b py-1 text-black/20'>
                <div>
                    <BringzzIcon
                        folder='HealthIcons'
                        icon='IconPharmacy'
                        size='22'
                        className='p-3 rounded-full' />
                </div>
                <div className='flex w-full items-center'>
                    <BringzzText tag='h3' className='text-black/20'>Pharmacy</BringzzText>
                </div>
            </div>
        );
    }

    return (
        <div className='flex space-x-4 border-b py-2'>
            <div>
                <BringzzIcon
                    folder='HealthIcons'
                    icon='IconPharmacy'
                    size='22'
                    className='p-3 rounded-full' />
            </div>
            <div className='flex w-full justify-between'>
                <div>
                    <BringzzText tag='h3'>Pharmacy</BringzzText>
                    <BringzzText tag='h4' className={"font-light"}>{pharmacy.name || "pharmacy_name"}</BringzzText>
                </div>
                <div className='flex items-center space-x-2'>
                    <BringzzIcon
                        folder='LineIcons'
                        icon='IconInfoCircle'
                        size='22'
                        className='cursor-pointer'
                        onClick={() => {
                            navigate(`/pharmacy/profile/${pharmacy.integrationId}`);
                        }} />
                    <BringzzIcon
                        folder='LineIcons'
                        icon='IconPhone'
                        size='16'
                        className='cursor-pointer'
                        onClick={() => {
                            window.open(`tel:${pharmacy.telefon}`, '_blank');
                        }} />
                    <BringzzIcon
                        folder='LineIcons'
                        icon='IconSupport'
                        size='21'
                        className='cursor-pointer'
                        onClick={() => {
                            navigate(`/settings/chats/${pharmacist.id}`);
                        }} />
                </div>
            </div>
        </div>
    );
};

export default BringzzPharmacyCardSmall;